import { CommandBase } from "../CommandBase.js";

export class CatCommand extends CommandBase {
    async execute(args) {
        const pathArg = args[0];
        const otherArgs = args.slice(1);
        
        if (!pathArg) {
            this.write("Usage: cat [file_path] [access_code]", "text-muted");
            return;
        }

        // 1. Get result from VFS (Now includes IDs)
        const result = this.fileSystem.cat(pathArg, otherArgs);

        if (result.type === 'error') {
            this.write(result.content, 'text-red');
            return;
        }

        // 2. SMART LOADING: Check if VFS provided a Content ID
        let fullContent = null;

        const meta = result.meta || {}; 
        const contentId = meta.id || result.project_id || result.blog_id; // Fallbacks

        if (meta.kind === 'project' || result.project_id) {
             this.write("Fetching project data...", "text-muted");
             const project = await this.contentManager.getProject(contentId);
             if (project) fullContent = project.body_html || project.description;
        } 
        else if (meta.kind === 'blog' || result.blog_id) {
             this.write("Fetching report data...", "text-muted");
             const blog = await this.contentManager.getBlogPost(contentId);
             if (blog) fullContent = blog.content || blog.body_html || blog.excerpt;
        }

        // 3. RENDER: If we found rich content, use the Buffer (Modal)
        if (fullContent) {
            // Clean up the filename for the header
            const filename = pathArg.split('/').pop();
            this.terminal.enterBufferMode(fullContent, `FILE: ${filename} // Press 'q' to quit`);
        } 
        // 4. Fallback: If it was just a normal text file (or fetch failed), dump to flow
        else {
            // If it was a stub file but fetch failed, show stub. 
            // If it was a normal text file (welcome.txt), show text.
            if (pathArg.endsWith('.info')) {
                 this.terminal.enterBufferMode(result.content, `FILE: ${pathArg} // Press 'q' to quit`);
            } else {
                 this.write(result.content, result.className || '');
            }
        }
    }
}